import { QRCodeCanvas } from "qrcode.react";
import copy from 'copy-to-clipboard';
import { useId } from "react";
import NotificationAlert from '~/other/NotificationAlert';

export default function QRCode({
    link,
    downloadTitle,
    showCopyAction = false,
    showDownloadAction = true,
    size = 128,
    ...props
}) {
    const canvasId = useId();

    const downloadQR = () => {
        const canvas = document.getElementById(canvasId);
        const downloadLink = document.createElement("a");
        downloadLink.href = canvas.toDataURL();
        downloadLink.download = downloadTitle || "ZeroQRCode.png";
        downloadLink.click();
    };

    const copyLink = () => {
        NotificationAlert("success", "", "Link copied!");
        copy(link);
    };

    return (
        <div {...props}>
            <div
                style={{
                    display: "inline-flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "0.5rem",
                }}
            >
                <QRCodeCanvas value={link} level={"M"} marginSize={0} id={canvasId} size={size} />
                {showDownloadAction && (
                    <span className="blue-link" onClick={downloadQR}>
                        Download QR
                    </span>
                )}
                {showCopyAction && (
                    <span className="blue-link" onClick={copyLink}>
                        Copy Link
                    </span>
                )}
            </div>
        </div>
    );
}